<h1>Inspiration and background</h1>
<p>
  20 years ago, my mum offered me a Murano paperweight. I started to get
  interested in paperweights, and I collected a few hundreds of them.
</p>
<p>
  There are different types of paperweight, and Murano (an island near Venice)
  is a typical kind. Murano paperweights are made of <i>millefiori canes</i>.
  <i>Millefiori</i>
  means "thousand flowers" in Italian, and a <i>cane</i> is a cross section of a
  cylindrical composite cane from colored rods, which looks like a flower.
</p>
<p>
  These canes are produced semi industrially since the Ancient Romans - and
  largely exported. Millefiori canes were even found in the Sutton Hoo Anglo Saxon
  burial site.
</p>
